import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { getApiError } from "../../services/courseApi";
import {
  createOrganization,
  getOrganization,
  updateOrganization,
} from "../../services/organizationApi";
import "../course/course.css";
import "./organization.css";

export default function OrganizationForm() {
  const { organizationId } = useParams();
  const edit = Boolean(organizationId);
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [status, setStatus] = useState("ACTIVE");
  const [loading, setLoading] = useState(edit);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!edit) return;
    async function load() {
      try {
        const organization = await getOrganization(organizationId);
        setName(organization.name || "");
        setStatus(organization.status || "ACTIVE");
      } catch (error) {
        toast.error(getApiError(error, "Could not load organization"));
      } finally {
        setLoading(false);
      }
    }
    load();
  }, [edit, organizationId]);

  async function submit(event) {
    event.preventDefault();
    const cleanName = name.trim();
    if (!cleanName) {
      toast.error("Organization name is required");
      return;
    }
    setSaving(true);
    try {
      const organization = edit
        ? await updateOrganization(organizationId, { name: cleanName, status })
        : await createOrganization({ name: cleanName });
      toast.success(edit ? "Organization updated" : "Organization created");
      navigate(`/organizations/${organization.organization_id || organizationId}`);
    } catch (error) {
      toast.error(getApiError(error, "Could not save organization"));
    } finally {
      setSaving(false);
    }
  }

  if (loading) {
    return <div className="course-state"><div className="spinner-border text-primary" /></div>;
  }

  return (
    <main className="course-page organization-form-page">
      <Link className="course-back-link" to={edit ? `/organizations/${organizationId}` : "/organizations"}>
        <i className="bi bi-arrow-left me-2" />
        {edit ? "Back to organization" : "Back to organizations"}
      </Link>
      <div className="course-page-header mt-3">
        <div>
          <p className="course-eyebrow">Organization management</p>
          <h1>{edit ? "Edit organization" : "Create organization"}</h1>
          <p className="text-muted mb-0">
            Membership will not affect a guru’s personal students or payments.
          </p>
        </div>
      </div>
      <form className="course-panel" onSubmit={submit}>
        <label className="course-form-field">
          <span>Organization name <em>*</em></span>
          <input
            className="form-control"
            maxLength="150"
            autoFocus
            value={name}
            onChange={(event) => setName(event.target.value)}
          />
        </label>
        {edit && (
          <label className="course-form-field mt-3">
            <span>Status</span>
            <select className="form-select" value={status} onChange={(event) => setStatus(event.target.value)}>
              <option value="ACTIVE">Active</option>
              <option value="INACTIVE">Inactive</option>
            </select>
          </label>
        )}
        <div className="d-flex justify-content-end gap-2 mt-4">
          <Link className="btn btn-outline-secondary" to={edit ? `/organizations/${organizationId}` : "/organizations"}>
            Cancel
          </Link>
          <button className="btn btn-primary" type="submit" disabled={saving}>
            {saving ? "Saving…" : edit ? "Save changes" : "Create organization"}
          </button>
        </div>
      </form>
    </main>
  );
}
